import { config } from '@/api/front_config'

let conf = config["HOST_SETTINGS"]

async function generateBody(data){
    var formBody = [];
    for (var property in data) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    return formBody;
}


export async function makeLogIn(login, password){
    var body = await generateBody({ 'username': login,
                                    'password': password })
    var result = await fetch(`${ conf["host_url"] }/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Private-Network": "true",
                'Access-Control-Allow-Origin': '*',
            },
            body: body
        })
    if(result.ok){
        result = await result.json()
        return result.access_token
    }
    return false
}

export async function getState(login, token){
    var result = await fetch(`${ conf["host_url"] }/state?` + 
                             new URLSearchParams({"email": login}), {
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
    if(result.ok){
        result = await result.json()
        return result.state
    }
    console.log(result)
    return false
}